import { DD } from "@/constants/testIds";
import { ChevronRight } from "lucide-react";
import CitedText from "@/components/CitedText";

const STATUS_STYLES = {
    green:        { dot: "bg-emerald-500",  text: "text-emerald-700", label: "GREEN" },
    amber:        { dot: "bg-amber-500",    text: "text-amber-700",   label: "AMBER" },
    red:          { dot: "bg-rose-600",     text: "text-rose-700",    label: "RED" },
    insufficient: { dot: "bg-slate-400",    text: "text-slate-600",   label: "INSUFFICIENT" },
};

export default function RagDashboard({ rows, annexure, onSelect }) {
    if (!rows || rows.length === 0) return null;
    const cues = rows.filter((r) => r.id !== "overall");
    const overall = rows.find((r) => r.id === "overall");
    return (
        <section data-testid="dd-rag-dashboard" className="mb-10">
            <div className="text-[10px] uppercase tracking-[0.2em] font-mono text-ciff-inkSoft mb-2 no-print-pdf">
                RAG dashboard · click any row for detail
            </div>
            <div className="border border-ciff-rule overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-ciff-paper2 text-ciff-ink">
                        <tr className="text-left">
                            <th className="px-3 py-2 font-semibold w-10">#</th>
                            <th className="px-3 py-2 font-semibold">Dimension</th>
                            <th className="px-3 py-2 font-semibold w-32">Status</th>
                            <th className="px-3 py-2 font-semibold">Key finding</th>
                            <th className="px-3 py-2 font-semibold w-6 no-print-pdf"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {cues.map((row) => {
                            const s = STATUS_STYLES[row.status] || STATUS_STYLES.insufficient;
                            return (
                                <tr
                                    key={row.id}
                                    data-testid={`dd-rag-row-${row.id}`}
                                    onClick={() => onSelect(row.id)}
                                    className="border-t border-ciff-rule cursor-pointer hover:bg-ciff-paper2 transition-colors duration-100"
                                >
                                    <td className="px-3 py-2.5 text-ciff-inkSoft font-mono text-xs">{row.id}</td>
                                    <td className="px-3 py-2.5 text-ciff-ink font-medium">{row.dimension}</td>
                                    <td className="px-3 py-2.5">
                                        <span className="inline-flex items-center gap-1.5">
                                            <span className={`w-2 h-2 rounded-full ${s.dot}`} />
                                            <span className={`text-xs font-semibold ${s.text}`}>{s.label}</span>
                                        </span>
                                    </td>
                                    <td className="px-3 py-2.5 text-ciff-inkSoft text-[13px] leading-snug">
                                        <CitedText text={row.finding} annexure={annexure} />
                                    </td>
                                    <td className="px-3 py-2.5 text-ciff-inkSoft no-print-pdf">
                                        <ChevronRight className="h-4 w-4" strokeWidth={1.75} />
                                    </td>
                                </tr>
                            );
                        })}
                        {overall && (
                            <tr className="border-t-2 border-ciff-ink bg-ciff-paper2">
                                <td className="px-3 py-3 text-ciff-ink font-mono text-xs"></td>
                                <td className="px-3 py-3 text-ciff-ink font-bold font-heading text-base">OVERALL</td>
                                <td className="px-3 py-3">
                                    <span className="inline-flex items-center gap-1.5">
                                        <span className={`w-2.5 h-2.5 rounded-full ${(STATUS_STYLES[overall.status] || STATUS_STYLES.insufficient).dot}`} />
                                        <span className={`text-xs font-bold ${(STATUS_STYLES[overall.status] || STATUS_STYLES.insufficient).text}`}>
                                            {(STATUS_STYLES[overall.status] || STATUS_STYLES.insufficient).label}
                                        </span>
                                    </span>
                                </td>
                                <td className="px-3 py-3 text-ciff-ink font-medium text-[13px]" colSpan={2}>
                                    <CitedText text={overall.finding} annexure={annexure} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </section>
    );
}
